import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';

const Error = () => {
  return (
    <div>
      <header class="header-container">
        <div class="logo-container">
          <div class="logo-image">
            <img alt="EY logo" src="/images/EYLogo.svg" />
          </div>
          <div class="logo-separator"></div>
          <span class="header-iml">
            <span class="header-text">EY Mobility Pathway</span>
          </span>
        </div>
      </header>
      <div className="error-container">
        <div className="body">
          <ErrorIcon className="error-icon" />
          <h1>Something has gone wrong.</h1>
          <p>It's not your fault! Please try refreshing</p>
          <p>your browser and if the problem persists,</p>
          <p>
            <a href="mailto: pathway.support@ey.com">contact support</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Error;
